import React, {useState} from "react"
import {useTranslation} from "next-i18next"
import Typography from "../Typography/Typography"
import {X} from "react-bootstrap-icons"
import AskUsEverythingForm from "../../forms/AskUsEverythingForm"
import styles from "./AskUsEverythingModalContent.module.scss"

type Props = {closeModal: ()=>void}

const AskUsEverythingModalContent: React.FC<Props> = ({closeModal}) => {
	const {t} = useTranslation()
	const [isSubmitError, setIsSubmitError] = useState<boolean>(false)
	const [isSubmitSuccess, setIsSubmitSuccess] = useState<boolean>(false)
	return (

		<div className={`${styles.fixedWrapper}`}>
			<div className={`${styles.modalWrapper} position-relative px-md-0 `}>

				<button onClick={() => closeModal()}
					className={"d-none d-md-block position-absolute btn   p-0 top-0 end-0"}
					style={{
						marginTop: "3%",
						marginRight: "4%",
						zIndex: 1
					}}>
					<X size={30}
						color={"black"}/>
				</button>

				<div style={{borderTopRightRadius: "16px", borderTopLeftRadius: "16px"}}
					className="row position-relative mt-md-3 mx-0 justify-content-between">
					<div className={`${styles.contentWrapper} positon-relative col-12 col-md-12 bg-white  py-md-4 pb-4 px-md-4 d-flex justify-content-center align-items-center`}>
						<div className="container px-0 ps-md-0 ps-md-3 pe-md-3">
							<button onClick={() => closeModal()}
								className={"d-md-none position-absolute bg-light btn btn-light btn-outline-light rounded-circle p-0 top-0 end-0"}
								style={{
									marginTop: "5%",
									marginRight: "3%",
									zIndex: 1
								}}>
								<X size={30}
									color={"dark"}/>
							</button>
							{!isSubmitError && !isSubmitSuccess && <div className="row mb-md-1">
								<Typography className="col-12 mb-3 mt-2 pt-2 d-md-none"
									variant="heading1Black"
									semanticTag="h2">{t("Stelle eine Frage")}</Typography>
								<Typography style={{fontSize: 36}}
									className="col-12 mb-2 mt-4 d-none d-md-block"
									variant="heading1Black"
									semanticTag="h2">{t("Stelle eine Frage")}</Typography>
								<Typography className="mb-md-2 mb-3"
									variant="bodyLg">{t("ask-all-your-questions-modal-text")}</Typography>
							</div>}
							<div className={"row mb-0"}>
								<AskUsEverythingForm isSubmitError={isSubmitError}
									setIsSubmitError={setIsSubmitError}
									isSubmitSuccess={isSubmitSuccess}
									setIsSubmitSuccess={setIsSubmitSuccess}
									closeModal={closeModal}/>
							</div>

						</div>
					</div>

				</div>

			</div>

		</div>
	)
}

export default AskUsEverythingModalContent
